// Arabic-only version - language toggle removed
const LanguageToggle = () => {
  return null; // No language toggle needed for Arabic-only interface
};

export default LanguageToggle;
